import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './FormButtons.styles';
import Button from './Button';
import InputGroup, { positionEnum } from '../fields/InputGroup';

const FormButtons = ({ submitDisabled, onCancel, submitLabel, cancelLabel, style }) => {
  const classes = useStyles();

  const { isSubmitting } = useFormikContext();
  return (
    <Grid item xs={12} className={classes.buttons}>
      <InputGroup position={positionEnum.right}>
        <Button type="button" onClick={onCancel} className={classes.cancelButton}>
          {!cancelLabel ? i18n.t('common.button.cancel') : cancelLabel}
        </Button>

        <Button primary type="submit" style={style} disabled={isSubmitting || submitDisabled}>
          {submitLabel}
        </Button>
      </InputGroup>
    </Grid>
  );
};

FormButtons.propTypes = {
  submitDisabled: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  submitLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string,
  style: PropTypes.shape(),
};

FormButtons.defaultProps = {
  cancelLabel: undefined,
  submitDisabled: false,
  style: undefined,
};

export default React.memo(FormButtons);
